module.exports = __webpack_public_path__ + "img/solution-lightXML-system-pic-1.9d5db01a.jpeg";